/* eslint-disable no-nested-ternary */
import React from "react";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from "prop-types";

const styles = {
  root: {
    fontFamily:
      '"HelveticaNeue-Light", "Helvetica Neue Light", "Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif',
    fontWeight: 300
  },
  header: {
    backgroundColor: "var(--white)",
    color: "var(--blue-lefebvre)",
    padding: "16px",
    paddingTop: "19px",
    fontSize: "1em",
    height: "62px",
    marginLeft: "1px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    zIndex: 100,
    position: "relative"
  }
};

const MaterialTitlePanel = props => {
  const rootStyle = props.style
    ? { ...styles.root, ...props.style }
    : styles.root;

  const _handleOnClick = () => {
    props.sidebarDocked();
  };

  const _handleOnClickExpand = () => {
    const lexon = props.lexon.lexonToken ? props.lexon.lexonToken : props.lexon.user;
    const { configCalendar } = props.lexon;
    const shortProvider =
      configCalendar && configCalendar.provider
        ? configCalendar.provider.substring(0, 2).toUpperCase()
        : null;

    if (shortProvider && shortProvider !== props.lexon.provider) {
      props.onSetSidebarOpenCalendar(false);
    } else if (props.lexon.lexonToken) {
      window.open(`/calendar/access/${lexon}/?prov=IM0`, '_blank');
    } else if (props.lexon.user) {
      window.open(`/calendar/user/${lexon}`, '_blank');
    } else {
      window.open('/calendar', '_blank');
    }
  };

  return (
    <div style={rootStyle}>
      <div style={styles.header}>
        <span className="inter-semibold-14">{props.title}</span>
        <div className="d-flex align-items-center">
          <div
            className={`${!props.showExpandIcon ? "hidden" : "cursor-pointer"}`}
            onClick={() => _handleOnClickExpand()}>
            <img
              src="/assets/icons/lexon/explore.svg"
              alt="explore"
              className="
               lf-icon
               lf-icon-open-window
               icon-open-window-calendar"
            />
          </div>
          <img
            src="/assets/icons/lexon/close-sm.svg"
            alt="close"
            className="
            lf-icon
            lf-icon-close
            icon-connect-lexon
            cursor-pointer"
            onClick={() => _handleOnClick()}
          />
        </div>
      </div>
      {props.children}
    </div>
  );
};

MaterialTitlePanel.propTypes = {
  style: PropTypes.object,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.object,
  sidebarDocked: PropTypes.func
};

MaterialTitlePanel.defaultProps = {
  sidebarDocked: () => {}
};

const mapStateToProps = state => ({
  lexon: state.lexon
});

export default connect(
  mapStateToProps,
  null
)(MaterialTitlePanel);
